import * as React from 'react';
import { VictoryPie, VictoryTheme } from 'victory';

interface IProps {
    data: { x: string, y: number }[],
    height?: number,
}

export default class Widget extends React.Component<IProps, {}> {
    static propTypes = {
        data: React.PropTypes.array.isRequired,
        height: React.PropTypes.number,
    };

    renderLabel(datum) {
        if (datum.y > 0) {
            return `${datum.xName}: ${datum.y}`;
        }

        return '';
    }

    render() {
        const { data } = this.props;

        return (
            <VictoryPie
                data={data}
                labels={this.renderLabel}
                height={(this.props.height || 600)}
                width={920}
                theme={VictoryTheme.material}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/common/Chart/SimplePieChart.tsx